import { v4 as uuid } from "uuid";
import { HelpText } from "../../../components/HelpText";
import { LocationData } from "../../../types/data";
import { Warehouse } from "../hooks/useFindLogic";
import styles from "./WarehouseMap.module.css";

interface Props {
  warehouse: Warehouse;
  warehouseLocations: (string | null)[][];
  data: LocationData[] | undefined;
}

export const WarehouseMap = ({ warehouse, warehouseLocations, data }: Props) => {
  if (warehouse === Warehouse.NONE) return null;

  return (
    <>
      <HelpText>
        Mapa magazynu, która po każdym kliknięciem wyświetla inną cześć, ASMAT, JAMS, brak. Niebieskie pola oznaczają,
        że w danym pionie regału znajdują się szukane EAN-y. Liczba oznacza ilość znalezionych EAN-ów.
      </HelpText>

      <div className={styles.warehouse}>
        <div className={styles.shelfLabel}>{warehouse === Warehouse.ASMAT ? "ASMAT (D)" : "JAMS (J)"}</div>
        <table>
          <tbody>
            {warehouseLocations.map((row) => (
              <tr key={uuid()}>
                {row.map((cell) => {
                  if (!cell) return <td key={uuid()} className={styles.nospace} />;

                  const found = data?.find((d) => d.location.startsWith(cell));

                  return (
                    <td key={uuid()} className={found ? styles.checked : ""}>
                      {found ? found.results.length : 0}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
